import { useContext } from "react";
import { ToastContext } from "../../../../hooks/context";
import { WarningDialog } from "../../../common";
import { useDeleteSmsCampaigns } from "../../../../hooks/api/mutations/useMarketing";

export const DeleteSmsCampaign = ({
  selectItem = {},
  closeModal = () => {},
}) => {
  const triggerToast = useContext(ToastContext);
  const { mutate: deleteCampaign, isLoading: isDeletingCampaign } =
    useDeleteSmsCampaigns();

  const handleDeleteCampaign = () => {
    deleteCampaign(
      { id: selectItem?.id },
      {
        onSuccess: () => {
          triggerToast("Campaign deleted successfully", "success");
          closeModal();
        },
      },
    );
  };

  return (
    <WarningDialog
      closeModal={() => closeModal()}
      handler={() => handleDeleteCampaign()}
      isLoading={isDeletingCampaign}
    >
      <p>
        Campaign Name: <span className="dark--text">{selectItem?.title}</span>
      </p>
      <p>
        No. of Audience:{" "}
        <span className="dark--text">
          {selectItem?.recipient_count_estimate}
        </span>
      </p>
    </WarningDialog>
  );
};
